import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";
import { formatNum } from "@/utils/manga";
import SectionTitle from "@/components/feature/SectionTitle";

const colorMap: Record<string, string> = {
  primary: "text-primary-600",
  accent: "text-accent-600",
  secondary: "text-secondary-600",
};

export default function Categories() {
  return (
    <section className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20" id="categories">
      <SectionTitle
        eyebrow="全题材分类"
        title="漫画分类大全"
        subtitle="恋爱、热血、悬疑、治愈等十大热门题材，点选分类快速找到你喜欢的漫画类型。"
        to="/category/love"
        moreLabel="进入分类"
      />
      <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 md:gap-4 lg:grid-cols-5">
        {categories.map((c) => (
          <Link
            key={c.id}
            to={`/category/${c.id}`}
            className="group relative overflow-hidden rounded-lg border border-background-200/70 bg-background-50 transition-all duration-300 hover:-translate-y-1 hover:border-primary-200 hover:shadow-sm"
          >
            <div className="relative aspect-[3/2] w-full overflow-hidden bg-background-200">
              <img
                src={c.cover}
                alt={`${c.name} 漫画分类`}
                loading="lazy"
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/75 to-transparent"></div>
              <div className="absolute inset-x-0 bottom-0 flex items-center justify-between p-3">
                <div>
                  <p className="font-heading text-lg text-background-50">{c.name}</p>
                  <p className="text-xs text-background-50/80">{formatNum(c.count)} 部作品</p>
                </div>
                <span
                  className={`flex h-8 w-8 items-center justify-center rounded-full bg-background-50/15 text-lg ${colorMap[c.color] || "text-primary-500"}`}
                >
                  <i className={c.icon} />
                </span>
              </div>
            </div>
            <div className="p-3">
              <p className="truncate text-sm text-foreground-600">{c.tagline}</p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}